"use strict";
// ================================================================
// v2/theme/pickFilledInk.ts
// 塗り(filled)面に乗せる文字色を、面の明度から選ぶ。
//
// なぜ計算するのか:
//   filled の面色はモードで明暗が反転する。light の info は #1990F6 (濃い面)
//   だが dark の info は #6CB6FF (淡い面) で、白文字だと 2.15:1 しか出ない。
//   さらに background.primary.* は withV2BrandColors がアプリの theme.json の
//   色に差し替えるため、静的なトークンでは正しい文字色を決められない。
//   そこで「白で足りるか」を面ごとに判定し、足りなければ濃いインクに倒す。
// ================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickFilledInk = pickFilledInk;
var material_1 = require("@mui/material");
/**
 * 明るいインク (白) を使うために必要な最低コントラスト比。
 *
 * AA (4.5) ではなく 3 にしているのは、light の意味色を Figma どおり
 * 白文字のまま維持するため (info #1990F6 は白で 3.30、warning #D36500 は 3.72)。
 * ここを 4.5 にすると承認済みの light デザインまで塗り替えてしまう。
 */
var MIN_CONTRAST_FOR_LIGHT_INK = 3;
/**
 * 面色に対して読める文字色を返す。
 *
 * @param surface 塗り面の色 (hex / rgb() / hsl() など getContrastRatio が解釈できる形式)
 * @param palette useV2Palette() の戻り値
 */
function pickFilledInk(surface, palette) {
    var _a = palette.foreground.filledInk, light = _a.light, dark = _a.dark;
    try {
        return (0, material_1.getContrastRatio)(surface, light) >= MIN_CONTRAST_FOR_LIGHT_INK
            ? light
            : dark;
    }
    catch (_b) {
        // CSS 変数やグラデーションなど解釈できない値が来た場合は
        // Figma 既定の白に倒す (throw させて画面を落とさない)
        return light;
    }
}
